<template>
  <div style="background: #efeff4">
    <div style="padding: 1rem;background: white;">
      <img
        :src="detail.picUrl"
        style="width: 100%;border-radius: .5rem;"
        alt=""
      />
    </div>
    <div style="margin-top: 1rem;padding: 1rem;background: white;">
      <div style="font-weight: 600;font-size: 1.2rem;">{{ detail.name }}</div>
      <!-- <div style="margin-bottom: 1rem;font-weight: 600;font-size: 1.2rem;">
        科室详情
      </div> -->
      <div v-html="intro"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      intro: ""
    };
  },
  created() {
    this.detail = this.$route.params || {};
    this.intro = this.detail.intro;
  }
};
</script>
